// extracted by mini-css-extract-plugin
module.exports = {"ownersArray":"styles_ownersArray__Lwugg","sponsoredFee":"styles_sponsoredFee___3_zI"};